// Third-party
import React from 'react';

// Types
import ProposalTableColGroup from '@/types/proposal-table-col-group';

interface ColGroupProps {
  colgroup: ProposalTableColGroup;
}

export const ColGroup = ({ colgroup }: ColGroupProps) => (
  <colgroup>
    {colgroup.cols.map((col, colIndex) => (
      <col key={colIndex} className={col.className} span={col.span} />
    ))}
  </colgroup>
);
